<template>
  <div id="out-content">
    <div id="content">
      <div id="left-content">
        <div class="center">
          <div id="title-1">六六书签</div>
          <div id="title-2">LIULIU &nbsp BOOKMARK</div>
        </div>
      </div>
      <div id="right-content">
        <div id="form-content">
          <div id="title-3">注册</div>
          <div id="input-group">
            <a-form :form="form" @submit="handleSubmit" hideRequiredMark>
              <a-form-item v-bind="formItemLayout" class="input-small-margin">
                <span slot="label">
                  <a-icon
                    type="user"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  placeholder="请输入您的昵称"
                  v-decorator="[
                    'nickName',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入您的昵称',
                          whitespace: true,
                        },
                        {
                          validator: validateNickName,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                v-bind="formItemLayout"
                has-feedback
                class="input-small-margin"
              >
                <span slot="label">
                  <a-icon
                    type="unlock"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  v-decorator="[
                    'password',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入您的密码!',
                        },
                        {
                          validator: validateToNextPassword,
                        },
                      ],
                    },
                  ]"
                  type="password"
                />
              </a-form-item>
              <a-form-item
                v-bind="formItemLayout"
                has-feedback
                class="input-small-margin"
              >
                <span slot="label">
                  <a-icon
                    type="unlock"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  v-decorator="[
                    'confirm',
                    {
                      rules: [
                        {
                          required: true,
                          message: '确认密码!',
                        },
                        {
                          validator: compareToFirstPassword,
                        },
                      ],
                    },
                  ]"
                  type="password"
                  @blur="handleConfirmBlur"
                  pla
                />
              </a-form-item>

              <a-form-item v-bind="formItemLayout" class="input-small-margin">
                <span slot="label">
                  <a-icon
                    type="mail"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  placeholder="请输入邮箱"
                  v-decorator="[
                    'email',
                    {
                      rules: [
                        {
                          type: 'email',
                          message: '请输入正确的邮箱!',
                        },
                        {
                          required: true,
                          message: '请输入您的邮箱!',
                        },
                        {
                          validator: validateEmail,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>

              <a-form-item v-bind="formItemLayout" class="input-small-margin">
                <span slot="label">
                  <a-icon
                    type="safety-certificate"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  placeholder="请输入验证码"
                  v-decorator="[
                    'code',
                    {
                      rules: [{ required: true, message: '请输入您的验证码!' }],
                    },
                  ]"
                >
                  <a-tooltip slot="suffix">
                    <div id="get-code" @click="getCode" v-show="time <= 0">
                      获取验证码
                    </div>
                    <div id="get-code" :disabled="true" v-show="time > 0">
                      {{ time }}秒重新获取
                    </div>
                  </a-tooltip>
                </a-input>
              </a-form-item>

              <a-form-item v-bind="tailFormItemLayout">
                <a-button
                  type="primary"
                  html-type="submit"
                  :style="{ width: '85%' }"
                >
                  注册
                </a-button>
                <router-link to="/login">
                  <div id="btn-text">已有账号，立即登录！</div>
                </router-link>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disBt: false,
      time: 0,
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 2 },
          sm: { span: 18 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 46,
            offset: 4,
          },
          sm: {
            span: 24,
            offset: 2,
          },
        },
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "register" });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          values.userName=values.email;
          this.$req.post("/api/user/register", values, (res) => {
            this.$router.push("/");
          });
        }
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次密码不一致，请重新输入!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    validateNickName(rule, value, callback) {
      const form = this.form;
      this.$req.formDataPost(
        "/api/user/check/nick-name",
        { nickName: value },
        (res) => {
          if (res.data) {
            callback();
          } else {
            callback("昵称已存在，请重新更换一个试试");
          }
        }
      );
    },
    validateEmail(rule, value, callback) {
      const form = this.form;
      this.$req.formDataPost(
        "/api/user/check/email",
        { email: value },
        (res) => {
          if (res.data) {
            callback();
          } else {
            callback("邮箱已存在，请重新更换一个试试");
          }
        }
      );
    },
    getCode() {
      let that = this;
      this.form.validateFields(["email"], (err, values) => {
        if (!err) {
          let email = this.form.getFieldValue("email");
          this.$req.formDataPost(
            "/api/user/register/code",
            { email: email },
            (res) => {
              that.$message.success("验证码已发送！");
            }
          );
          let current = Date.now();
          var timeInterval = setInterval(function () {
            that.time = parseInt(30 - (Date.now() - current) / 1000);
          }, 999);

          setTimeout(function () {
            clearInterval(timeInterval);
          }, 30000);
        }
      });
    },
  },
};
</script>

<style scoped >
#out-content {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/img/image4.png");
}

#content {
  width: 866px;
  height: 533px;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

#left-content {
  width: 466px;
  height: 100%;
  float: left;
  background-color: #19a0fb;
  opacity: 0.6;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

#right-content {
  width: 400px;
  height: 100%;
  float: left;
  background-color: #ffffff;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.center {
  width: 184px;
  height: 66px;
  margin: auto;
  margin-top: 45%;
}
#title-1 {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  line-height: 46px;
  /* identical to box height */

  letter-spacing: 0.4em;
  text-align: left;
  color: #ffffff;
}
#title-2 {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 18px;
  letter-spacing: 0.1em;

  color: #ffffff;
  text-align: left;
  opacity: 0.5;
}

#title-3 {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  line-height: 46px;
  color: #19a0fb;
  text-align: center;
  margin-bottom: 22px;
}

#form-content {
  width: 266px;
  height: 400px;
  margin: 67px 67px 0 67px;
}
#input-group {
  width: 266px;
  height: 236px;
}
.input-small-margin {
  margin-bottom: 12px !important;
}
#get-code {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #19a0fb;
}
#btn-text {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #999999;
}
</style>